/* eslint-disable import/extensions */
import 'angular';
import 'angular-aria';
import 'angular-route';
import 'angular-translate';
import 'angular-translate-once';
import 'ng-redux';

import Moment from 'moment-timezone';
import 'moment/locale/ca';
import 'moment/locale/de';
import 'moment/locale/es';
import 'moment/locale/fr';
import 'moment/locale/fr-ca';
import 'moment/locale/nl';
import 'moment/locale/pt';
import 'moment/locale/pt-br';

window.moment = Moment;

require('../../../../node_modules/angular-translate/dist/angular-translate.js');
require('../../../../node_modules/angular-translate/dist/angular-translate-loader-static-files/angular-translate-loader-static-files.js');
